export default {
  dark: 'Oscuro',
  light: 'Claro',
};
